module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "文件上传",
      "name": "first"
    }
  }, [_c('el-row', [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.detail,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File Name",
      "prop": "sFileName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "readonly": "",
      "disabled": "",
      "placeholder": "Please select file(excel)"
    },
    model: {
      value: (_vm.detail.sFileName),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sFileName", $$v)
      },
      expression: "detail.sFileName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "upload-button"
  }, [_vm._v("\n                Select\n                "), _c('input', {
    attrs: {
      "id": "files",
      "type": "file"
    },
    on: {
      "change": _vm.changeFile
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结存版本号",
      "prop": "sVersion"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.sVersion),
      callback: function($$v) {
        _vm.sVersion = $$v
      },
      expression: "sVersion"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指标名称",
      "prop": "sName"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.sName),
      callback: function($$v) {
        _vm.sName = $$v
      },
      expression: "sName"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板名称",
      "prop": "nTemplateId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.nTemplateId),
      callback: function($$v) {
        _vm.nTemplateId = $$v
      },
      expression: "nTemplateId"
    }
  }, _vm._l((_vm.options3), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a8b0e01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/upload/tupload.vue
// module id = 670
// module chunks = 1